import { useLayoutContext } from "arkh";
import { useSizeClass } from "../../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

export function useWidgetMargin() {
  const layout = useLayoutContext();
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  return isCompact ? layout.space.xsmall : layout.space.small;
}
